import React, { useEffect, useState } from 'react'

export default function Reference(props) {

    const preTag = props.pretag || ''
    const [tag, setTag] = useState(null)
    const [name, setName] = useState(null)
    const [noRef, setNoRef] = useState(false)
    const data = props.attr['data-data'];

    useEffect(() => {
        setName(props.name.children[0].data)
         data !== "[]" ? setTag(preTag+JSON.parse(data.replaceAll("'", '"'))[0].section_id) : setNoRef(true)
    }, [])

    return (
        name ?
        <span key={tag} className="theme-reference" onClick={() => tag && props.selectedReference(tag)}>
            {name}
        </span>
        : null
    )
}
